export default __webpack_public_path__ + "static/media/ShortlistGreen.3f983536.svg";